import $ from 'jquery';
var moment = require('moment');
require('daterangepicker');

import Chart from 'chart.js/auto';

window.moment = moment;
window.Chart = Chart;
window.$ = $;
window.jQuery = $;


window.loadSlick = function () {
	return import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick');
};

window.loadChoices = function () {
	return import(/* webpackChunkName: "choices" */ 'choices.js').then(function (module) {
		return module.default;
	});
};

var magnificPopupPromise = null;
window.loadMagnificPopup = function () {
	if (!magnificPopupPromise) {
		magnificPopupPromise = import(/* webpackChunkName: "magnific-popup" */ 'magnific-popup');
	}
	return magnificPopupPromise;
};

window.loadJsPDF = function () {
	return Promise.all([
		import(/* webpackChunkName: "jspdf" */ 'jspdf'),
		import(/* webpackChunkName: "jspdf" */ 'jspdf-autotable'),
	]).then(function (modules) {
		return modules[0].default;
	});
};

window.loadXLSX = function () {
	return import(/* webpackChunkName: "xlsx" */ 'xlsx');
};
